import CatePostModal from "./CatePostModal.presenter";
export default CatePostModal;
